import moment from "moment-timezone";

export const timezones: { label: string }[] = moment.tz.names().map((x) => ({
  label: x,
}));
